<template>
  <b-overlay :show="homeLoading" class="rounded" variant="transparent">
    <template #overlay>
      <b-img
        width="100"
        :src="require('@/assets/img/brand/loader.gif')"
        alt=""
      />
    </template>
    <Bar :chart-data="chartData" :height="250" :chartOptions="optionsChart" />
  </b-overlay>
</template>
<script>
import { Bar } from "vue-chartjs/legacy";
import { mapGetters } from "vuex";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);
export default {
  components: {
    Bar,
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      dataStadistic: "home/getPointsGenerated",
      homeLoading: "home/homeLoading",
    }),

    optionsChart() {
      return {
        plugins: {
          legend: false,
        },
        scales: {
          x: {
            title: {
              display: true,
              text: this.$t("type"),
              color: "green",
              font: {
                weight: "bold",
                size: 15,
                lineHeight: 2,
              },
            },
          },
          y: {
            ticks: {
              min: 0,
              max: 10,
              stepSize: Math.round(
                (this.dataStadistic.super_admin +
                  this.dataStadistic.matched_interest) /
                  18
              ),
              reverse: false,
              beginAtZero: true,
            },
            title: {
              display: true,
              text: this.$t("quantity"),
              color: "green",
              font: {
                weight: "bold",
                size: 15,
                lineHeight: 2,
              },
            },
          },
        },
      };
    },
    chartData() {
      return {
        labels: [this.$t("add-by-m2m"), this.$t("referrals-between-users")],
        datasets: [
          {
            label: "",
            backgroundColor: [
              "rgba(255, 99, 132, 0.7)",
              "rgba(54, 162, 235, 0.7)",
            ],
            borderWidth: 5,
            data: [
              this.dataStadistic.super_admin,
              this.dataStadistic.matched_interest,
            ],
          },
        ],
      };
    },
  },
};
</script>